import { put, all, takeEvery, fork } from "redux-saga/effects";
import { actions as SessionFlyOverActions } from "Portal/NewPortal/Sections/Sessions/FlyOver/model";
import { actions } from "./model";

const init = function*() {
  yield put(SessionFlyOverActions.setFromHomePage(true));
  yield put(actions.setLoading(false));
};

const watchInit = function*() {
  yield takeEvery(actions.init.type, init);
};

const rootSaga = function*() {
  yield all([fork(watchInit)]);
};

export default rootSaga;
